/* The + at the end of the column headers: tick everyone else who is in today
 * and add them in one go. Only offers staff not already on the board. */
import * as Vue from 'vue';
import { store } from '../store.js';

export const AddStaff = {
  name: 'AddStaff',
  setup: function () {
    var open = Vue.computed(function () { return store.ui.addStaff; });

    var picked = Vue.computed(function () {
      return open.value ? open.value.ids.length : 0;
    });

    // What a new column joins on, so the count is not a surprise afterwards.
    var missed = Vue.computed(function () { return store.floorTurnsCompleted(); });

    // Whole-label interpolation rather than text beside a {{ }}: the compiler
    // condenses the space between them away and it reads "Add2".
    var addLabel = Vue.computed(function () {
      return picked.value ? 'Add ' + picked.value : 'Add';
    });

    /* Opening the salon is the common case and it is everybody, so it is one
     * press rather than a tick per name. It fills the boxes rather than marking
     * anyone in: the tags saying who starts on which turn are the reason this
     * sheet exists, and a button that skipped them would be putting people on
     * the board without showing what it was about to charge them. */
    var allPicked = Vue.computed(function () {
      var n = store.addableStaff.value.length;
      return !!(open.value && n && open.value.ids.length === n);
    });

    function toggleAll() {
      if (!open.value) return;
      open.value.ids = allPicked.value
        ? []
        : store.addableStaff.value.map(function (s) { return s.id; });
    }

    return {
      open: open,
      picked: picked,
      missed: missed,
      addLabel: addLabel,
      allPicked: allPicked,
      toggleAll: toggleAll,
      isNewToday: store.isNewToday,
      addable: store.addableStaff,
      services: store.activeServices,
      toggle: store.toggleAddStaff,
      confirm: store.confirmAddStaff,
      close: store.closeAddStaff
    };
  },
  template: [
    '<div v-if="open" class="modal-scrim" @click.self="close">',
    '  <div class="sheet" role="dialog" aria-modal="true">',
    '    <div class="sheet__head sheet__head--plain">',
    '      <div>',
    '        <h3>Who else is in today?</h3>',
    '        <p v-if="addable.length">Everyone on the roster who is not on the board yet.</p>',
    '        <p v-else>Everyone on the roster is already in.</p>',
    '      </div>',
    '      <button v-if="addable.length > 1" type="button" class="link-btn"',
    '        @click="toggleAll">{{ allPicked ? "Clear" : "Everyone" }}</button>',
    '    </div>',
    '',
    '    <div class="assign__section">',
    '      <p v-if="!addable.length" class="appt-empty">',
    '        Nobody left to add. New technicians go in under Settings &rarr; Staff.</p>',
    '      <ul v-else class="pick-list">',
    '        <li v-for="s in addable" :key="s.id">',
    '          <button type="button" class="pick pick--check" :class="{ \'is-on\': open.ids.includes(s.id) }"',
    '            role="checkbox" :aria-checked="open.ids.includes(s.id) ? \'true\' : \'false\'"',
    '            @click="toggle(s.id)">',
    '            <span class="pick__box" aria-hidden="true">{{ open.ids.includes(s.id) ? "\\u2713" : "" }}</span>',
    '            <span class="pick__main">',
    '              <span class="pick__client">{{ s.name }}</span>',
    '              <span class="pick__svc">',
    '                <template v-if="s.serviceIds.length">',
    '                  {{ services.filter(v => s.serviceIds.includes(v.id)).map(v => v.name).join(", ") }}',
    '                </template>',
    '                <template v-else>No services set up</template>',
    '              </span>',
    '            </span>',
    /* Only a first mark-in today is charged missed turns; someone coming back
       from being marked out keeps the place they already had. */
    '            <span v-if="!isNewToday(s.id)" class="pick__tag is-later">Back</span>',
    '            <span v-else-if="missed > 0" class="pick__tag is-later">Turn {{ missed + 1 }}</span>',
    '          </button>',
    '        </li>',
    '      </ul>',
    '      <p v-if="addable.length && missed > 0" class="setting__hint">',
    '        The floor has finished <strong>{{ missed }}</strong>',
    '        {{ missed === 1 ? "turn" : "turns" }}. Anyone new starts on turn',
    '        <strong>{{ missed + 1 }}</strong> with the squares above them slashed;',
    '        anyone marked <strong>Back</strong> keeps the place they already had.</p>',
    '    </div>',
    '',
    '    <div class="sheet__actions">',
    '      <button type="button" class="btn btn--primary btn--lg" :disabled="!picked" @click="confirm()">',
    '        {{ addLabel }}</button>',
    '      <button type="button" class="btn btn--quiet" @click="close">Cancel</button>',
    '    </div>',
    '  </div>',
    '</div>'
  ].join('\n')
};
